import Styled from 'styled-components';

const Container = Styled.div`
  order: 4;

  button {
    min-width: 16em;
  }
`;

Container.displayName = 'LandingCTAContainer';

export default Container;
